<script>
    import { formatUnits, parseUnits } from "ethers/lib/utils";
    import { formateToPrecision, formatScientificNumber, getTokenPrice } from "../../utils";
    import Button from "../button/Button.svelte";
    import Steps from "../steps/Steps.svelte";
    import { GET_TRANSACTION_LINK } from "../../constants/constants";
    import Ring from "../ring/Ring.svelte";
    import { BigNumber, ethers } from "ethers";
    import {transactionStore} from '../../stores/transactionStore'
    import Input from "../input/Input.svelte";
    import { projectDetail, projectSaleDetails, tokenPurchased} from "../../store";
    import { isTransactionConfirmed } from "../../store";

    
    export let  sale, reserve, saleCardDetails;

    const TxStatus = {
        None: "None",
        AwaitingSignature: "AwaitingSignature",
        AwaitingConfirmation: "AwaitingConfirmation",
        Error: "Error",
    };

    const BuySteps = {
        Confirm: "Confirm",
        Complete: "Complete",
    };

    const PriceConfirmed = {
        Pending: "Pending",
        Confirmed: "Confirmed",
    };

    const inputValueStatuses = {
        VALID: "",
        NEGATIVE_ERROR: "Only Positive values allowed",
        EXCEED_LIMIT: "Entered amount exceeds available limit",
        INVALID_INPUT: "Invalid Input",
        LOW_BALANCE: `You don't have enough ${reserve.erc20symbol}`,
    };

    const getAccountBalance = () => {
        return Number(
            formatUnits(reserve.erc20balance, reserve.erc20decimals.toString())
        );
    };
    let units,
        buyUnit,
        fee = 0,
        activeStep = BuySteps.Confirm,
        txStatus = TxStatus.None,
        priceConfirmed = PriceConfirmed.Pending,
        txReceipt,
        errorMsg,
        calcPricePromise,
        inputValueStatus,
        isWalletCapExceeded = false;

    const calculatePrice = async (amount) => {
        amount = Number(amount);

        isWalletCapExceeded =
            amount + $tokenPurchased <=
            formatUnits(
                $projectSaleDetails.calculatePriceStateConfig.constants[1]
            )
                ? false
                : true;
        
        priceConfirmed = PriceConfirmed.Pending;
        const one = parseUnits(
            '1',
            $projectSaleDetails.token.decimals.toString()
        );
        const _units = parseUnits(
            formatScientificNumber(amount).toString(),
            $projectSaleDetails.token.decimals.toString()
        );
        units = _units;
        const price = ethers.utils.parseUnits(saleCardDetails.price.toString(), reserve.erc20decimals.toString());
        const subtotal = price.mul(_units).div(one);
        if($transactionStore.percentageFee){
            fee = subtotal.mul(BigNumber.from($transactionStore.percentageFee * 100)).div(BigNumber.from(10000));
        }
        const total = subtotal.add(fee);

        priceConfirmed = PriceConfirmed.Confirmed;

        return {
            subtotal,
            fee,
            total,
        };
    };

    const buy = async () => {

        const buyConfig = {
            feeRecipient: $transactionStore.recepientAddress,
            fee: fee,
            minimumUnits: units,
            desiredUnits: units,
            maximumPrice: ethers.constants.MaxUint256,
        };

        let tx;
        txStatus = TxStatus.AwaitingSignature;

        try {
            tx = await sale.buy(buyConfig);
        } catch (error) {
            errorMsg = error.message;
            txStatus = TxStatus.Error;
            if (errorMsg.length > 500) errorMsg = "Something went wrong";
            console.log(error);
            return;
        }

        txStatus = TxStatus.AwaitingConfirmation;
        txReceipt = await tx.wait();
        txStatus = TxStatus.None;
        activeStep = BuySteps.Complete;
        setTimeout(() => {
            isTransactionConfirmed.set(true);
        }, 5000);
    };
    const isValidInput = (value) => {
        
        if(isNaN(value)){
            inputValueStatus = "INVALID_INPUT";
            return false;
        }

        if (value <= 0) {
            inputValueStatus = "NEGATIVE_ERROR";
            return false;
        }
        if (
            value * Number(getTokenPrice($projectSaleDetails)) >
            getAccountBalance()
        ) {
            inputValueStatus = "LOW_BALANCE";
            return false;
        }   
         
        // if (
        //     value >
        //         Number(
        //             +formatUnits(
        //                 $projectSaleDetails.unitsAvailable,
        //                 $projectSaleDetails.token.decimals
        //             )
        //         )
        // ) {
        //     inputValueStatus = "EXCEED_LIMIT";
        //     return false;
        // }


        inputValueStatus = "VALID";
        return true;
    };

    const buyMaxTokens = () => {
        let accountBalance = getAccountBalance();
        if (saleCardDetails.walletCap - $tokenPurchased <= 0 || !accountBalance)
            return;
        const maxWalletBuyLimit =
            accountBalance /
            (saleCardDetails.price + saleCardDetails.price * $transactionStore.percentageFee / 100);
        const maxWalletCap = (saleCardDetails.walletCap - $tokenPurchased).toFixed(6) / 1;
        if (maxWalletBuyLimit < maxWalletCap) buyUnit = maxWalletBuyLimit;
        else buyUnit = maxWalletCap;
        
        let totalAvailable = Number(
                    +formatUnits(
                        $projectSaleDetails.unitsAvailable,
                        $projectSaleDetails.token.decimals
                    )
                );
        if(buyUnit > totalAvailable)
            buyUnit = totalAvailable;

        calcPricePromise = isValidInput(buyUnit) && calculatePrice(buyUnit);
    };

   
</script>

{#if txStatus === TxStatus.None}
    <div class="flex column-direction buy-modal">
        <Steps
            steps={["Confirm", "Complete"]}
            {activeStep}
            fulfilledTextClass="text-gray-100"
            lineBorderClass="border-gray-400"
        />
        {#if activeStep === BuySteps.Confirm}
            <h1 class="modal-title">
                Buy {$projectSaleDetails.token.symbol}
            </h1>
            <div class="input-modal-wrap relative">
                <Input
                        id="by-token-modal"
                        type="string"
                        debounce
                        autocomplete={false}
                        on:input={({ detail }) => {
                           
                    calcPricePromise =
                        isValidInput(detail) && calculatePrice(detail);
                }}
                        bind:value={buyUnit}
                        maxLength={14}
                >
                <span class="title" slot="label"
                >Enter the number of units to buy:</span
                >
                </Input>
                <Button buttonClass={"input-tag-btn "} on:click={buyMaxTokens}>Max Buy</Button
                >
            </div>
            <div class="info-wrapper">
                {#if inputValueStatus && inputValueStatus !== "VALID"}
                    <span class="warning"
                        >*{inputValueStatuses[inputValueStatus]}</span
                    >
                {/if}
            </div>
            {#if calcPricePromise}
                <div class="white info-wrapper flex column-direction">
                    {#await calcPricePromise}
                        Getting price...
                    {:then result}
                        {#if !isWalletCapExceeded && inputValueStatus === "VALID"}
                            <div class="flex flex-wrap history">
                                <span
                                    >Price: {getTokenPrice(
                                        $projectSaleDetails
                                    )}
                                    {$projectSaleDetails.reserve.symbol} per {$projectSaleDetails.token.symbol}</span
                                >
                                <span class="ml-auto"
                                    >Total: {
                                    formatScientificNumber(
                                    formateToPrecision(
                                        formatUnits(
                                            result.total,
                                            $projectSaleDetails.reserve
                                                .decimals
                                        ))
                                    )}
                                    {$projectSaleDetails.reserve
                                        .symbol}</span
                                >
                            </div>
                            <span
                                >Fee: {$transactionStore.percentageFee}%
                            </span>
                            <Button
                                buttonClass={"submit-btn "}
                                disabled={!priceConfirmed}
                                on:click={buy}
                                >Buy {$projectSaleDetails.token
                                    .symbol}</Button
                            >
                        {:else}
                            <span class="warning">
                                *Entered amount exceeds individual purchase
                            limit</span>
                        {/if}
                    {/await}
                </div>
            {/if}
        {/if}
        {#if activeStep === BuySteps.Complete && inputValueStatus}
            <span class="modal-title">Purchase confirmed!</span>
            <a
                class="text-blue-400 underline"
                target="_blank"
                href={ GET_TRANSACTION_LINK($projectDetail.chain?.chain_id, txReceipt?.transactionHash) }>See transaction.</a>
            >
        {/if}
    </div>
{/if}

{#if txStatus === TxStatus.AwaitingSignature}
    <div class="flex items-center">
        <Ring color="#fff" />
        <span class="text-lg">Awaiting signature...</span>
    </div>
{/if}
{#if txStatus === TxStatus.AwaitingConfirmation}
    <div class="flex items-center">
        <Ring color="#fff" />
        <span class="text-lg">Transaction confirming...</span>
    </div>
{/if}
{#if txStatus === TxStatus.Error}
    <div class="flex column-direction buy-modal items-center">
        <span class="modal-title">Something went wrong.</span>
        <span class="text-lg text-red-400">{errorMsg}</span>
    </div>
{/if}

<style>
    span.text-lg {
        color: #fff;
    }
    .buy-modal span.title {
        font-size: 18px;
        line-height: 22px;
        color: #fff;
        margin: 0 0 12px;
        display: block;
    }
    .info-wrapper span {
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 15px;
        font-weight: 300;
    }
    .info-wrapper .warning {
        color: red;
        font-weight: bold;
    }
    .white {
        color: #fff;
    }
</style>
